enum PublishRequestEntityType {
  FlowModel = 0,
  Procedure = 1
}

export default PublishRequestEntityType;
